var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-nav"},[_c('Nav'),_c('div',{staticClass:"wrap-content"},[_vm._l((_vm.menuAwards),function(menu,index){return [(menu.isActive)?_c(menu.componentName,{key:index,tag:"component"}):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }